module.exports = __webpack_public_path__ + "img/orkocraft.37f9f540.webp";